export const actions = {
  UPDATE_AUTHORITIES: "UPDATE_AUTHORITIES",
  TOKEN_EXPIRE: "TOKEN_EXPIRE",
  LOG_OUT: "LOG_OUT",
  FETCH_CITIES: "FETCH_CITIES",
  SELECTED_DATE_FILTER: "SELECTED_DATE_FILTER",
  SELECTED_CITY: "SELECTED_CITY",
  CONTRACT_TYPE: "CONTRACT_TYPE",
  CONTRACT_STATE_DATA: "CONTRACT_STATE_DATA",
  MENU_TYPE: "MENU_TYPE",
  UPDATE_USER: "UPDATE_USER",
  FETCH_OPERATORS: "FETCH_OPERATORS",
  CITY_OPERATORS: "CITY_OPERATORS",
  REFRESH_UPLIFT: "REFRESH_UPLIFT",
  CURRENTDUE_VEHICLES: "CURRENTDUE_VEHICLES",
  PREVIOUS_SETTLEMENT: "PREVIOUS_SETTLEMENT",
  PENDING_SETTLEMENT: "PENDING_SETTLEMENT",
  SETTLED_SETTLEMENT: "SETTLED_SETTLEMENT",
  SETTLEMENT_SUMMARY: "SETTLEMENT_SUMMARY",
  SETTLEMENT_LEDGER: "SETTLEMENT_LEDGER",
  SETTLEMENT_UPLOAD: "SETTLEMENT_UPLOAD",
  SETTLEMENT_UPLOAD_FAILURE: "SETTLEMENT_UPLOAD_FAILURE",
  GROSS_CONTRIBUTION_UPLOAD: "GROSS_CONTRIBUTION_UPLOAD",
  GROSS_CONTRIBUTION_UPLOAD_FAILURE: "GROSS_CONTRIBUTION_UPLOAD_FAILURE",
  ONDC_UPLOAD_FAILURE: "ONDC_UPLOAD_FAILURE",
  ONDC_UPLOAD: "ONDC_UPLOAD",
  SELECTED_OPERATOR: "SELECTED_OPERATOR",
  FETCH_OPERATION_TYPE: "FETCH_OPERATION_TYPE",
  SELECTED_OPERATION_TYPE: "SELECTED_OPERATION_TYPE",
  FETCH_REPORTS_TYPE: "FETCH_REPORTS_TYPE",
  SELECTED_REPORTS_TYPE: "SELECTED_REPORTS_TYPE",
  FETCH_COLLECTION: {
    FETCH_VEHICLE_WISE_COLLECTION: "FETCH_VEHICLE_WISE_COLLECTION",
    FETCH_DAY_WISE_COLLECTION: "FETCH_DAY_WISE_COLLECTION",
    FETCH_COLLECTION_SUMMARY: "FETCH_COLLECTION_SUMMARY",
  },
  FETCH_OVERVIEW: {
    FETCH_OVERVIEW_SUMMARY: "FETCH_OVERVIEW_SUMMARY",
    FETCH_FINANCIAL_OVERVIEW: "FETCH_FINANCIAL_OVERVIEW",
    FETCH_ONLINE_RECHARGE_SUMMARY: "FETCH_ONLINE_RECHARGE_SUMMARY",
    FETCH_GC_OVERVIEW: "FETCH_GC_OVERVIEW",
  },
  FETCH_CARD_COLLECTION: {
    FETCH_VEHICLE_WISE_CARD_COLLECTION: "FETCH_VEHICLE_WISE_CARD_COLLECTION",
    FETCH_DAY_WISE_CARD_COLLECTION: "FETCH_DAY_WISE_CARD_COLLECTION",
    FETCH_CARD_COLLECTION_SUMMARY: "FETCH_CARD_COLLECTION_SUMMARY",
    FETCH_ISSUE_TICKET_CARD: "FETCH_ISSUE_TICKET_CARD",
    FETCH_CARD_ISSUED: "FETCH_CARD_ISSUED",
    FETCH_CARD_RECHARGED: "FETCH_CARD_RECHARGED",
  },
  FETCH_BREAK_DOWN_COLLECTION: {
    FETCH_VEHICLE_WISE_BREAK_DOWN_COLLECTION: "FETCH_VEHICLE_WISE_BREAK_DOWN_COLLECTION",
    NAV_DATA: "NAV_DATA",
    FETCH_DAY_WISE_BREAK_DOWN_COLLECTION: "FETCH_DAY_WISE_BREAK_DOWN_COLLECTION",
    BREAK_DOWN_VIEW: "BREAK_DOWN_VIEW",
    FETCH_DATE_DUE_BREAK_DOWN_COLLECTION: "FETCH_DATE_DUE_BREAK_DOWN_COLLECTION",
    FETCH_BREAK_DOWN_COLLECTION_SUMMARY: "FETCH_BREAK_DOWN_COLLECTION_SUMMARY",
  },
  FETCH_VEHICLE: {
    FETCH_VEHICLE_LIST: "FETCH_VEHICLE_LIST",
  },
  FETCH_VEHICLE_CONTRACTS: "FETCH_VEHICLE_CONTRACTS",
  NOTIFICATION: "NOTIFICATION",
  FETCH_DISTANCE_REPORTS: "FETCH_DISTANCE_REPORTSS",
  FETCH_MOBILE_TICKETS_REPORTS: "FETCH_MOBILE_TICKETS_REPORTS",
  FETCH_DISTANCE_REPORTS_DETAILS: "FETCH_DISTANCE_REPORTS_DETAILS",
  FETCH_MOBILE_TICKETS_DETAILS: "FETCH_MOBILE_TICKETS_DETAILS",
  FETCH_MOBILE_SETTLEMENT_DETAILS: "FETCH_MOBILE_SETTLEMENT_DETAILS",
  DISTANCE_REPORTS_DATA_SYNC: "DISTANCE_REPORTS_DATA_SYNC",
  DISTANCE_UPLOAD_FAILURE: "DISTANCE_UPLOAD_FAILURE",
  FETCH_PASS_REPORTS: "FETCH_PASS_REPORTS",
  FETCH_PASS_DETAILS: "FETCH_PASS_DETAILS",
  FETCH_PASS_SETTLEMENT_DETAILS: "FETCH_PASS_SETTLEMENT_DETAILS",
  FETCH_OPERATOR_WISE_REPORT: "FETCH_OPERATOR_WISE_REPORT",
  EXPORT_BUTTON_PAGE: {
    ADD_PAGE_NAME: "ADD_PAGE_NAME",
    REMOVE_PAGE_NAME: "REMOVE_PAGE_NAME",
  },
  FETCH_REPORTS_MODULE: {
    FETCH_REPORTS_MODULE_TYPES: "FETCH_REPORTS_MODULE_TYPES",
    SELECTED_REPORTS_MODULE_TYPE: "SELECTED_REPORTS_MODULE_TYPE",
    FETCH_USER_GENERATED_REPORTS: "FETCH_USER_GENERATED_REPORTS",
    FETCH_LINK_AND_DOWNLOAD_REPORT: "FETCH_LINK_AND_DOWNLOAD_REPORT",
  },
  FETCH_ALL_OPERATOR_EXPENSES: "FETCH_ALL_OPERATOR_EXPENSES",
  CREATE_OPERATOR_EXPENSES: "CREATE_OPERATOR_EXPENSES",
  FETCH_OPERATOR_EXPENSE_LIST: "FETCH_OPERATOR_EXPENSE_LIST",
  CLEAR_OPERATOR_EXPENSE_LIST: "CLEAR_OPERATOR_EXPENSE_LIST",
  EXPENSE_UPLOAD: "EXPENSE_UPLOAD",
  EXPENSE_UPLOAD_FAILURE: "EXPENSE_UPLOAD_FAILURE",

  // Admin Config Action
  FETCH_ALL_CITY_CONFIGS: "FETCH_ALL_CITY_CONFIGS",
  FETCH_CITY_AGENCIES: "FETCH_CITY_AGENCIES",
  UPSERT_CITY_CONFIGS: "UPSERT_CITY_CONFIGS",
  // Pass Revenue Action
  FETCH_ALL_OPERATOR_PASS_REVENUE: "FETCH_ALL_OPERATOR_PASS_REVENUE",
  CREATE_OPERATOR_PASS_REVENUE: "CREATE_OPERATOR_PASS_REVENUE",
  CLEAR_OPERATOR_PASS_REVENUE: "CLEAR_OPERATOR_PASS_REVENUE",
  FETCH_PASS_REVENUE_CITIES: "FETCH_PASS_REVENUE_CITIES",
  PASS_REVENUE_UPLOAD: "PASS_REVENUE_UPLOAD",
  PASS_REVENUE_UPLOAD_FAILURE: "PASS_REVENUE_UPLOAD_FAILURE",
  // Operator Settlement Config
  CITY_OPERATOR: "CITY_OPERATOR",
  SETTLEMENT_CYCLE: "SETTLEMENT_CYCLE",
  // Subscription plan
  SUBSCRIPTION_PLAN_DETAILS: "SUBSCRIPTION_PLAN_DETAILS",
  OPERATOR_CONFIG_EDIT: "OPERATOR_CONFIG_EDIT",
  OPERATOR_CONFIG_CITY: "OPERATOR_CONFIG_CITY",
  FETCH_OPERATOR_CONFIG: "FETCH_OPERATOR_CONFIG",
};
